module.exports = __webpack_public_path__ + "static/media/clock.1950ada1.svg";